import Link from 'next/link';

import { abbreviateNumber } from 'mode-shared/utils';
import { DetailsCollapsiblePanel } from './DetailsCollapsiblePanel';
import { CampaignImages } from './CampaignImages';
import { CombinedCampaign } from 'mode-shared/hooks/dashboard/types';
import { ExternalLinkIcon } from '../icons';

export const CampaignDetails = ({ campaigns }: { campaigns: CombinedCampaign[] }) => {
  return (
    <>
      {campaigns.map((campaign) => {
        const hasAPR = campaign.apr > 0;
        const isType1Campaign = campaign.campaign_type == 1;

        return (
          <div key={campaign.campaign_id} className="w-full flex flex-col gap-2">
            <div className="w-full flex justify-between bg-neutral-1000 rounded-lg p-4 border border-neutral-900">
              <div className="flex gap-2 items-center">
                <CampaignImages
                  campaignToken0Image={campaign.token_0_image || ''}
                  campaignToken0Name={campaign.token_0_name}
                  campaignToken1Image={campaign.token_1_image || ''}
                  campaignToken1Name={campaign.token_1_name}
                  isType1Campaign={isType1Campaign}
                />

                <div className="flex flex-col gap-1">
                  {isType1Campaign ? (
                    <p className="font-primary font-semibold text-grey-500 uppercase">{campaign.card_name}</p>
                  ) : (
                    <p className="font-primary font-semibold text-grey-500 uppercase">{`${campaign.token_0_name} - ${campaign.token_1_name}`}</p>
                  )}

                  <div className="flex gap-1">
                    {campaign.reward_tokens.map((token) => (
                      <div key={`rewards-${token.reward_token_address}`} className="group flex gap-1">
                        <div className="flex text-[13px] leading-5 text-grey-600">
                          <p>
                            <span className="font-medium">{abbreviateNumber(token.reward_token_amount)}</span>{' '}
                            <span className="uppercase">{token.reward_token_name}</span>
                          </p>
                        </div>
                        <span className="group-last:hidden text-[13px] leading-5 text-grey-600">/</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {hasAPR && (
                  <p className="font-sans text-sm text-grey-600">{`${abbreviateNumber(campaign.apr)}% APR`}</p>
                )}
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href={campaign.campaign_url || 'https://merkl.angle.money/?chain=34443'}
                  className="flex items-center px-2 py-2 w-10 h-10 justify-center border-grey-700 bg-neutral-950 rounded"
                >
                  <ExternalLinkIcon className="text-neutral-100" size={16} />
                </Link>
              </div>
            </div>
            <DetailsCollapsiblePanel campaign={campaign} />
          </div>
        );
      })}
    </>
  );
};
